import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-yellow-500/40 bg-yellow-500/10 ${className}`} aria-hidden="true" data-id="element-114" data-mp="1zbqyo7zazzuw">
      <Icon className="h-6 w-6 text-yellow-500" strokeWidth={1.5} data-id="element-115" data-mp="2490m5i34u1g3" />
    </span>;
}